/**
 * Pages accessibles sans connexion. Les liens des e-mails de compte (AppSettings:ClientLoginUrl,
 * AppSettings:ClientResetPasswordUrl, AppSettings:ClientConfirmEmailUrl de l'API) pointent vers ces chemins : les
 * changer ensemble.
 */
export const PublicRoutes = {
  Login: '/cms/login',
  ChangePassword: '/cms/change-password',
  ForgotPassword: '/cms/forgot-password',
  ResetPassword: '/cms/reset-password',
  ConfirmEmail: '/cms/confirm-email',
};

/** Chemin exact, avec ou sans barre finale, ou sous-chemin d'une page publique. */
export const isPublicRoute = (pathname: string) => Object.values(PublicRoutes).some(route => pathname === route || pathname.startsWith(`${route}/`));
